export const PLG1 = 'R4_PLG1_course-v-dashboard';
export const PLG2 = 'R10_PLG2_header-button-cta';
